// extracted by mini-css-extract-plugin
module.exports = {"teamSettingsButtonWrapper":"style_teamSettingsButtonWrapper__3GlIE","teamSettingsTitle":"style_teamSettingsTitle__1sJkF"};